import { IELTSearch } from 'legacy/lut/classes/models/partner360/ELT/IELTSearch'

import { IColumn } from 'core-components/library/list/types'
import { getFormatDate } from 'core/classes/helpers/DateHelper'

import { getFormedEltTranslation } from '../../helpers/getFormedEltTranslation'

import { IS_PARTNER_GROUP } from './enums/IS_PARTNER_GROUP'

export const columns: IColumn<IELTSearch>[] = [
  {
    title: getFormedEltTranslation('elt-search-partner-id'),
    field: 'PartnerName',
    renderFunction: (item) => {
      if (item.IsPartnerGroup === IS_PARTNER_GROUP.yes) {
        return <div>{item.MainHQPartnerId}</div>
      }
      return <div>{item.PartnerId}</div>
    },
  },
  { title: getFormedEltTranslation('elt-search-name'), field: 'PartnerName' },
  {
    title: getFormedEltTranslation('elt-search-is-group'),
    field: 'IsPartnerGroup',
  },

  { title: getFormedEltTranslation('elt-search-FYear'), field: 'FYear' },
  { title: getFormedEltTranslation('elt-search-versions'), field: 'VersionsCount' },
  { title: getFormedEltTranslation('elt-search-last-modified-by'), field: 'LastModifiedBy' },
  { title: getFormedEltTranslation('elt-search-last-modified'), field: 'LastModified' },
]
